import CarsService from "../shared/services/carsService";

const ON_SELECT_TO_CHANGE_UNIT = "ON_SELECT_TO_CHANGE_UNIT";
const ON_CLEAR_TO_CHANGE_UNIT = "ON_CLEAR_TO_CHANGE_UNIT";

const selectToChangeUnitAction = (unit) => {
  return {
    type: ON_SELECT_TO_CHANGE_UNIT,
    unit,
  };
};

const clearToChangeUnitAction = () => {
  return {
    type: ON_CLEAR_TO_CHANGE_UNIT,
  };
};

const selectToChangeUnit = (unit) => {
  return (dispatch) => {
    dispatch(selectToChangeUnitAction(unit));
  };
};

const clearToChangeUnit = () => {
  return (dispatch) => {
    dispatch(clearToChangeUnitAction());
  };
};

const REQUEST_UPDATE_UNIT_SUPPORT = "REQUEST_UPDATE_UNIT_SUPPORT";
const RESPONSE_UPDATE_UNIT_SUPPORT = "RESPONSE_UPDATE_UNIT_SUPPORT";
const REQUEST_UPDATE_UNIT_SUPPORT_FAIL = "REQUEST_UPDATE_UNIT_SUPPORT_FAIL";

const requestUpdateUnitSupportAction = () => {
  return {
    type: REQUEST_UPDATE_UNIT_SUPPORT,
  };
};

const responseUpdateUnitSupportAction = (unitId, data) => {
  return {
    type: RESPONSE_UPDATE_UNIT_SUPPORT,
    unitId,
    data,
  };
};

const requestUpdateUnitSupportActionFail = () => {
  return {
    type: REQUEST_UPDATE_UNIT_SUPPORT_FAIL,
  };
};

const updateUnitSupport = (id, options) => {
  return (dispatch) => {
    dispatch(requestUpdateUnitSupportAction());

    CarsService.updateUnitSupport(id, options)
      .then((response) => {
        dispatch(responseUpdateUnitSupportAction(id, options));
      })
      .catch((error) => {
        dispatch(requestUpdateUnitSupportActionFail(error.response));
      });
  };
};

const REQUEST_UNIT_SHARED = "REQUEST_UNIT_SHARED";
const RESPONSE_UNIT_SHARED = "RESPONSE_UNIT_SHARED";
const REQUEST_UNIT_SHARED_FAIL = "REQUEST_UNIT_SHARED_FAIL";

const requestUnitSharedAction = () => {
  return {
    type: REQUEST_UNIT_SHARED,
  };
};

const responseUnitSharedAction = (data) => {
  return {
    type: RESPONSE_UNIT_SHARED,
    data,
  };
};

const requesUnitSharedActionFail = () => {
  return {
    type: REQUEST_UNIT_SHARED_FAIL,
  };
};

const unitShared = (id, options) => {
  return (dispatch) => {
    dispatch(requestUnitSharedAction());

    CarsService.unitShared(id, { companyId: options.id })
      .then((response) => {
        dispatch(responseUnitSharedAction(options));
      })
      .catch((error) => {
        dispatch(requesUnitSharedActionFail(error.response));
      });
  };
};

const REQUEST_UNIT_UN_SHARED = "REQUEST_UNIT_UN_SHARED";
const RESPONSE_UNIT_UN_SHARED = "RESPONSE_UNIT_UN_SHARED";
const REQUEST_UNIT_UN_SHARED_FAIL = "REQUEST_UNIT_UN_SHARED_FAIL";

const requestUnitUnSharedAction = () => {
  return {
    type: REQUEST_UNIT_UN_SHARED,
  };
};

const responseUnitUnSharedAction = (data) => {
  return {
    type: RESPONSE_UNIT_UN_SHARED,
    data,
  };
};

const requesUnitUnSharedActionFail = () => {
  return {
    type: REQUEST_UNIT_UN_SHARED_FAIL,
  };
};

const unitUnShared = (id, options) => {
  return (dispatch) => {
    dispatch(requestUnitUnSharedAction());

    CarsService.unitUnShared(id, { companyId: options.id })
      .then((response) => {
        dispatch(responseUnitUnSharedAction(options));
      })
      .catch((error) => {
        dispatch(requesUnitUnSharedActionFail(error.response));
      });
  };
};

const REQUEST_UNIT_SETTINGS = "REQUEST_UNIT_SETTINGS";
const RESPONSE_UNIT_SETTINGS = "RESPONSE_UNIT_SETTINGS";
const REQUEST_UNIT_SETTINGS_FAIL = "REQUEST_UNIT_SETTINGS_FAIL";

const requestUnitSettingsAction = () => {
  return {
    type: REQUEST_UNIT_SETTINGS,
  };
};

const responseUnitSettingsAction = (data) => {
  return {
    type: RESPONSE_UNIT_SETTINGS,
    data,
  };
};

const requesUnitSettingsActionFail = () => {
  return {
    type: REQUEST_UNIT_SETTINGS_FAIL,
  };
};

const getUnitSettings = (id) => {
  return (dispatch) => {
    dispatch(requestUnitSettingsAction());

    CarsService.getUnitSettings(id)
      .then((response) => {
        dispatch(responseUnitSettingsAction(buildSettingItems(response.data)));
      })
      .catch((error) => {
        dispatch(requesUnitSettingsActionFail(error.response));
      });
  };
};

const buildSettingItems = (data) => {
  const settingsGroups = [];

  for (const group of data.settingsGroups) {
    const settings = [];

    for (const item of group.settings) {
      const setting = {
        item,
        dependents: [],
      };

      if (item.requiredSettingId === null) {
        settings.push(setting);
      } else {
        const indx = settings.findIndex((setting) => {
          return setting.item.id === item.requiredSettingId;
        });

        if (indx !== -1) {
          settings[indx].dependents.push(item);
        }
      }
    }

    settingsGroups.push({ group: group.group, title: group.title, settings: settings });
  }

  return { settingsGroups };
};

const REQUEST_UPDATE_UNIT_SETTING = "REQUEST_UPDATE_UNIT_SETTING";
const RESPONSE_UPDATE_UNIT_SETTING = "RESPONSE_UPDATE_UNIT_SETTING";
const REQUEST_UPDATE_UNIT_SETTING_FAIL = "REQUEST_UPDATE_UNIT_SETTING_FAIL";

const requestUpdateUnitSettingAction = () => {
  return {
    type: REQUEST_UPDATE_UNIT_SETTING,
  };
};

const responseUpdateUnitSettingAction = (data) => {

  return {
    type: RESPONSE_UPDATE_UNIT_SETTING,
    data,
  };
};

const requesUpdateUnitSettingActionFail = (data) => {
  return {
    type: REQUEST_UPDATE_UNIT_SETTING_FAIL,
    data,
  };
};

const updatgeUnitSetting = (id, options) => {
  return (dispatch) => {
    dispatch(requestUpdateUnitSettingAction());

    CarsService.updateUnitSetting(id, options)
      .then((response) => {
        dispatch(responseUpdateUnitSettingAction(buildSettingItems(response.data)));
      })
      .catch((error) => {
        dispatch(requesUpdateUnitSettingActionFail(error.response.data));
      });
  };
};

const REQUEST_UPDATE_UNIT_INFORMATION = "REQUEST_UPDATE_UNIT_INFORMATION";
const RESPONSE_UPDATE_UNIT_INFORMATION = "RESPONSE_UPDATE_UNIT_INFORMATION";
const REQUEST_UPDATE_UNIT_INFORMATION_FAIL = "REQUEST_UPDATE_UNIT_INFORMATION_FAIL";

const requestUpdateUnitInformationAction = () => {
  return {
    type: REQUEST_UPDATE_UNIT_INFORMATION,
  };
};

const responseUpdateUnitInformationAction = (data) => {
  return {
    type: RESPONSE_UPDATE_UNIT_INFORMATION,
    data,
  };
};

const requesUpdateUnitInformationActionFail = (data) => {
  return {
    type: REQUEST_UPDATE_UNIT_INFORMATION_FAIL,
    data,
  };
};

const updatgeUnitInformation = (id, options) => {
  return (dispatch) => {
    dispatch(requestUpdateUnitInformationAction());

    CarsService.updateUnitInformation(id, options)
      .then((response) => {
        dispatch(responseUpdateUnitInformationAction(options));
      })
      .catch((error) => {
        dispatch(requesUpdateUnitInformationActionFail(error.response.data));
      });
  };
};

export {
  ON_SELECT_TO_CHANGE_UNIT,
  selectToChangeUnit,
  ON_CLEAR_TO_CHANGE_UNIT,
  clearToChangeUnit,
  REQUEST_UPDATE_UNIT_SUPPORT,
  RESPONSE_UPDATE_UNIT_SUPPORT,
  REQUEST_UPDATE_UNIT_SUPPORT_FAIL,
  updateUnitSupport,
  REQUEST_UNIT_SHARED,
  RESPONSE_UNIT_SHARED,
  REQUEST_UNIT_SHARED_FAIL,
  unitShared,
  REQUEST_UNIT_UN_SHARED,
  RESPONSE_UNIT_UN_SHARED,
  REQUEST_UNIT_UN_SHARED_FAIL,
  unitUnShared,
  REQUEST_UNIT_SETTINGS,
  RESPONSE_UNIT_SETTINGS,
  REQUEST_UNIT_SETTINGS_FAIL,
  getUnitSettings,
  REQUEST_UPDATE_UNIT_SETTING,
  RESPONSE_UPDATE_UNIT_SETTING,
  REQUEST_UPDATE_UNIT_SETTING_FAIL,
  updatgeUnitSetting,
  REQUEST_UPDATE_UNIT_INFORMATION,
  RESPONSE_UPDATE_UNIT_INFORMATION,
  REQUEST_UPDATE_UNIT_INFORMATION_FAIL,
  updatgeUnitInformation,
};
